import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { of } from 'rxjs';
import {catchError, map, switchMap, tap} from 'rxjs/operators';
import { ReportService } from '../../services/report.service';
import {
  shareReport,
  shareReportSuccess,
  shareReportFailure,
  editPromptFailure,
  editPromptSuccess,
  editPrompt,
  refineIcpScore,
  refineIcpScoreSuccess,
  refineIcpScoreFailure,
  changeCompany, changeCompanyFailure, changeCompanySuccess
} from './report.actions';
import {HubspotService} from "../../services/hubspot.service";

@Injectable()
export class ReportEffects {

  shareReport$ = createEffect(() =>
    this.actions$.pipe(
      ofType(shareReport),
      tap(() => console.log('Share Report effect triggered')),
      switchMap(({ email, search_id }) =>
        this.reportService.shareReport(email, search_id).pipe(
          tap(() => console.log('Calling share report service', email, search_id)),
          map(response => {
            if (!response || !response.data) {
              // If the response object is not structured as expected, throw an error
              throw new Error('Invalid share report response');
            }
            console.log('Share report successful', response.data);
            return shareReportSuccess();
          }),
          catchError(error => {
            console.log('Share report failed', error);
            return of(shareReportFailure({ error }));
          })
        )
      )
    )
  );

  editPrompt$ = createEffect(() =>
    this.actions$.pipe(
      ofType(editPrompt), // Trigger this effect when the editPrompt action is dispatched
      tap(() => console.log('Edit Prompt effect triggered')),
      switchMap(({ search_id, assistant_prompt_id, prompt_value }) =>
        this.reportService.updatePrompt(search_id, assistant_prompt_id, prompt_value).pipe(
          tap(() => console.log('Calling updatePrompt service', { search_id, assistant_prompt_id, prompt_value })),
          map(response => {
            if (!response || !response.data) {
              // Handle invalid response
              throw new Error('Invalid edit prompt response');
            }
            console.log('Edit prompt successful', response.data);
            return editPromptSuccess({ response: response.data }); // Dispatch success action
          }),
          catchError(error => {
            console.log('Edit prompt failed', error);
            return of(editPromptFailure({ error })); // Dispatch failure action
          })
        )
      )
    )
  );

  refineIcpScore$ = createEffect(() =>
    this.actions$.pipe(
      // Listen for the `refineIcpScore` action
      ofType(refineIcpScore),
      tap(() => console.log('Refine ICP Score effect triggered')),
      // Call the `refineIcpScore` service method when the action is dispatched
      switchMap(({ searchCompanyId, selectedValues, formValues }) =>
        this.reportService.refineIcpScore(searchCompanyId, selectedValues, formValues).pipe( // Use the service properly
          tap(() => console.log('Calling refine ICP score service', selectedValues, formValues)),
          // On success, dispatch the `refineIcpScoreSuccess` action
          map((response) => {
            if (!response || !response.data) {
              // If the response is not structured as expected, throw an error
              throw new Error('Invalid refine ICP score response');
            }
            console.log('ICP score refinement successful', response.data);
            return refineIcpScoreSuccess({ result: response.data });
          }),
          // On failure, dispatch the `refineIcpScoreFailure` action
          catchError((error) => {
            console.log('ICP score refinement failed', error);
            return of(refineIcpScoreFailure({ error }));
          })
        )
      )
    )
  );

  changeCompany$ = createEffect(() =>
    this.actions$.pipe(
      ofType(changeCompany),
      // tap(() => console.log('Change company effect triggered')),
      switchMap(({ searchId, organizationId }) =>
        this.reportService.changeCompany(searchId, organizationId).pipe(
          // tap((response) => console.log('API Response:', response)), // Log the API response
          map((response) => {
            if (!response || !response.data) {
              throw new Error('Invalid change company response');
            }
            return changeCompanySuccess({ response: response.data }); // Dispatch the action with the response data
          }),
          catchError((error) => {
            console.error('Change company failed', error);
            return of(changeCompanyFailure({ error }));
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private reportService: ReportService,
    private hubspotService: HubspotService
  ) {}
}
